// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2VpJH","content":"LayoutSettings_content__ZPRfk"};